import React from 'react';
import { cn } from '../lib/utils';

/**
 * DonutChart — circular progress chart, used for quota / plan breakdowns.
 *
 * props:
 *  value: number  (0..1)
 *  size: number  (diameter)
 *  strokeWidth: number
 *  color: string (CSS color)
 *  trackColor: string (defaults to border)
 *  label: string (rendered in the center)
 *  sublabel: string
 */
export function DonutChart({
  value,           // 0..1
  size = 120,
  strokeWidth = 10,
  color = 'hsl(var(--brand))',
  trackColor = 'hsl(var(--border))',
  label,
  sublabel,
  className,
}) {
  const clamped = Math.min(Math.max(value, 0), 1);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - clamped);

  return (
    <div className={cn('relative inline-flex items-center justify-center', className)}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={trackColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1)' }}
        />
      </svg>
      {(label || sublabel) && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          {label && <div className="text-lg font-semibold text-fg tabular-nums">{label}</div>}
          {sublabel && <div className="text-2xs text-fg-muted uppercase tracking-wider mt-0.5">{sublabel}</div>}
        </div>
      )}
    </div>
  );
}